import { render, staticRenderFns } from "./SpaceMembersForm.vue?vue&type=template&id=b9bf70b8&scoped=true&"
import script from "./SpaceMembersForm.vue?vue&type=script&lang=js&"
export * from "./SpaceMembersForm.vue?vue&type=script&lang=js&"
import style0 from "./SpaceMembersForm.vue?vue&type=style&index=0&id=b9bf70b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bf70b8",
  null
  
)

export default component.exports